import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSeleniumComponent } from './simple-icons-selenium.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSeleniumComponent ],
    exports:      [ SimpleIconsSeleniumComponent ],
    bootstrap:    []
})
export class SimpleIconsSeleniumModule {}
